document.addEventListener('DOMContentLoaded', () => {

  // Navigation dropdowns:
  // Desktop/laptop = hover + focus, and close as soon as the pointer leaves the
  // category + panel area. Mobile/tablet = tap to toggle + tap outside to close.
  const mainNav = document.querySelector('[data-main-nav]');
  const navItems = mainNav ? Array.from(mainNav.querySelectorAll('.nav-dropdown')) : [];
  const isDesktopNav = () => window.matchMedia('(min-width: 721px)').matches;

  const closeDropdown = (details) => {
    if (!details) return;
    details.open = false;
    const panel = details.querySelector('.nav-dropdown-panel');
    if (panel) {
      panel.style.removeProperty('position');
      panel.style.removeProperty('top');
      panel.style.removeProperty('left');
      panel.style.removeProperty('right');
      panel.style.removeProperty('width');
      panel.style.removeProperty('max-width');
      panel.style.removeProperty('z-index');
    }
  };

  const closeAllDropdowns = (except = null) => {
    navItems.forEach(item => {
      const details = item.querySelector(':scope > details');
      if (details && details !== except) closeDropdown(details);
    });
  };

  const positionDesktopPanel = (item, details) => {
    if (!isDesktopNav() || !details?.open) return;
    const panel = details.querySelector('.nav-dropdown-panel');
    if (!panel) return;

    const rect = item.getBoundingClientRect();
    const viewportGutter = 14;
    const panelWidth = Math.min(
      panel.classList.contains('nav-brands-panel') ? 700 : 610,
      window.innerWidth - viewportGutter * 2
    );
    const panelHeight = Math.min(panel.scrollHeight || 500, window.innerHeight - 110);
    let left = rect.left + (rect.width / 2) - (panelWidth / 2);
    left = Math.max(viewportGutter, Math.min(left, window.innerWidth - panelWidth - viewportGutter));

    panel.style.position = 'fixed';
    panel.style.top = `${Math.max(8, rect.bottom + 7)}px`;
    panel.style.left = `${left}px`;
    panel.style.right = 'auto';
    panel.style.width = `${panelWidth}px`;
    panel.style.maxWidth = `${window.innerWidth - viewportGutter * 2}px`;
    panel.style.maxHeight = `${Math.max(180, panelHeight)}px`;
    panel.style.zIndex = '99999';
  };

  const positionMobilePanel = (details) => {
    if (!mainNav || !details?.open || isDesktopNav()) return;
    const panel = details.querySelector('.nav-dropdown-panel');
    if (!panel) return;
    const navRect = mainNav.getBoundingClientRect();
    const gutter = 12;
    panel.style.position = 'fixed';
    panel.style.top = `${Math.max(8, navRect.bottom + 6)}px`;
    panel.style.left = `${gutter}px`;
    panel.style.right = `${gutter}px`;
    panel.style.width = 'auto';
    panel.style.maxWidth = 'none';
    panel.style.zIndex = '99999';
  };

  navItems.forEach(item => {
    const details = item.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details || !summary) return;

    // Desktop: open while the pointer is anywhere over the category or panel.
    item.addEventListener('mouseenter', () => {
      if (!isDesktopNav()) return;
      closeAllDropdowns(details);
      details.open = true;
      requestAnimationFrame(() => positionDesktopPanel(item, details));
    });

    item.addEventListener('mouseleave', () => {
      if (!isDesktopNav()) return;
      closeDropdown(details);
    });

    item.addEventListener('focusin', () => {
      if (!isDesktopNav()) return;
      closeAllDropdowns(details);
      details.open = true;
      requestAnimationFrame(() => positionDesktopPanel(item, details));
    });

    summary.addEventListener('click', (event) => {
      if (isDesktopNav()) {
        // Desktop uses hover. Prevent native <details> toggling on click.
        event.preventDefault();
        details.open = true;
        positionDesktopPanel(item, details);
        return;
      }

      // Mobile/tablet: tap toggles the menu and keeps all category panels aligned.
      event.preventDefault();
      const shouldOpen = !details.open;
      closeAllDropdowns();
      if (shouldOpen) {
        details.open = true;
        requestAnimationFrame(() => positionMobilePanel(details));
      }
    });
  });

  // Tap/click outside the navigation closes an open mobile dropdown.
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-main-nav] .nav-dropdown')) {
      closeAllDropdowns();
    }
  });

  const repositionOpenDropdown = () => {
    const openItem = navItems.find(item => item.querySelector(':scope > details[open]'));
    if (!openItem) return;
    const details = openItem.querySelector(':scope > details');
    if (isDesktopNav()) positionDesktopPanel(openItem, details);
    else positionMobilePanel(details);
  };

  window.addEventListener('resize', () => {
    closeAllDropdowns();
  });
  window.addEventListener('orientationchange', () => {
    closeAllDropdowns();
  });
  let navScrollFrame = 0;
  window.addEventListener('scroll', () => {
    if (navScrollFrame) return;
    navScrollFrame = requestAnimationFrame(() => {
      navScrollFrame = 0;
      if (isDesktopNav()) closeAllDropdowns();
      else repositionOpenDropdown();
    });
  }, { passive: true });

  const cfg = window.DELDERMA || {};

  const cartJsUrl = `${cfg.routes?.cart || '/cart'}.js`;
  const cartAddUrl = cfg.routes?.add || '/cart/add.js';
  const cartChangeUrl = cfg.routes?.change || '/cart/change.js';
  const checkoutUrl = cfg.routes?.checkout || '/checkout';

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>\"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[ch]));

  // Product gallery: every Shopify product image can be selected from thumbnails.
  const galleryMain = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (!galleryMain) return;
      galleryMain.src = thumb.dataset.imageSrc;
      if (thumb.dataset.imageSrcset) galleryMain.srcset = thumb.dataset.imageSrcset;
      galleryMain.alt = thumb.dataset.imageAlt || galleryMain.alt;
      document.querySelectorAll('[data-gallery-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });


  const search = document.querySelector('[data-search]');
  const suggestions = document.querySelector('[data-search-suggestions]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-drawer-overlay]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const drawerFoot = document.querySelector('[data-cart-drawer-foot]');
  const drawerTotal = document.querySelector('[data-cart-drawer-total]');
  let suggestionTimer;

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const fmt = cfg.moneyFormat || '₹{{amount}}';
    return fmt.replace(/{{\s*amount\s*}}/g, amount).replace(/{{\s*amount_no_decimals\s*}}/g, String(Math.round(Number(cents || 0) / 100)));
  };

  if (search && suggestions) {
    const searchForm = search.closest('.search');
    const mainNavForSearch = document.querySelector('[data-main-nav]');
    const closeSearchSuggestions = () => {
      suggestions.classList.remove('is-open');
      searchForm?.classList.remove('has-suggestions');
      mainNavForSearch?.classList.remove('search-is-active');
    };

    search.addEventListener('input', () => {
      clearTimeout(suggestionTimer);
      const q = search.value.trim();
      if (q.length < 2) { closeSearchSuggestions(); suggestions.innerHTML = ''; return; }
      suggestionTimer = setTimeout(async () => {
        try {
          const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          if (!response.ok) return;
          const data = await response.json();
          const products = data.resources?.results?.products || [];
          const escapeHtml = (value) => String(value ?? '').replace(/[&<>\"]/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;'}[ch]));
          suggestions.innerHTML = products.length ? `
            <div class="search-suggestions-head"><span>PRODUCTS</span><small>${products.length} suggestions</small></div>
            <div class="search-suggestions-list">
              ${products.map(p => {
                const image = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image?.url || '');
                return `<a href="${p.url}" class="search-suggestion-item">
                  <span class="search-suggestion-thumb">${image ? `<img src="${image}" alt="${escapeHtml(p.title)}" loading="lazy">` : '<span aria-hidden="true">✦</span>'}</span>
                  <span class="search-suggestion-copy"><strong>${escapeHtml(p.title)}</strong><small>${escapeHtml(p.vendor || 'DELDERMA')}</small></span>
                  <span class="search-suggestion-price">${escapeHtml(p.price)}</span>
                </a>`;
              }).join('')}
            </div>
            <button type="submit" class="search-suggestions-all">View all results for “${escapeHtml(q)}” <span>→</span></button>` : `
            <div class="search-suggestions-empty"><strong>No matching products yet</strong><span>Try a product name, brand or category.</span></div>`;
          suggestions.classList.add('is-open');
          searchForm?.classList.add('has-suggestions');
          mainNavForSearch?.classList.add('search-is-active');
        } catch (_) {}
      }, 180);
    });
    search.addEventListener('focus', () => { if (suggestions.innerHTML.trim() && search.value.trim().length >= 2) { suggestions.classList.add('is-open'); searchForm?.classList.add('has-suggestions'); mainNavForSearch?.classList.add('search-is-active'); } });
    document.addEventListener('click', (event) => { if (!event.target.closest('.search')) closeSearchSuggestions(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { closeSearchSuggestions(); search.blur(); } });
  }

  const setDrawerOpen = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    overlay?.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('cart-drawer-open', open);
    // Hide the product sticky purchase bar immediately, before cart content finishes loading.
    if (stickyCart) {
      stickyCart.hidden = open;
      stickyCart.setAttribute('aria-hidden', open ? 'true' : 'false');
    }
  };

  const updateHeaderCount = (count) => {
    const safeCount = Number(count || 0);
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = safeCount;
      el.setAttribute('aria-label', `${safeCount} items in cart`);
      el.classList.toggle('has-items', safeCount > 0);
    });
  };

  const notifyCartUpdated = (cart) => {
    document.dispatchEvent(new CustomEvent('delderma:cart-updated', { detail: { cart } }));
  };

  const renderDrawer = async () => {
    if (!drawerBody) return;
    try {
      const response = await fetch(cartJsUrl, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      const cart = await response.json();
      updateHeaderCount(cart.item_count);
      if (!cart.item_count) {
        drawerBody.innerHTML = `<div class="drawer-empty"><strong>Your cart is empty.</strong><span>Explore skincare, haircare and derma essentials.</span><a class="btn" href="/search?type=product">Shop products</a></div>`;
        if (drawerFoot) drawerFoot.hidden = true;
        notifyCartUpdated(cart);
        return cart;
      }
      drawerBody.innerHTML = cart.items.map((item, index) => {
        const image = item.featured_image?.url ? `<img src="${item.featured_image.url}&width=180" alt="${item.product_title.replace(/"/g, '&quot;')}">` : `<div class="product-placeholder"><strong>${item.product_title}</strong></div>`;
        return `<div class="drawer-item" data-line="${index + 1}"><a class="drawer-item-image" href="${item.url}">${image}</a><div class="drawer-item-info"><a class="card-title" href="${item.url}">${item.product_title}</a>${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}<strong>${formatMoney(item.final_line_price)}</strong><div class="drawer-qty"><button type="button" data-cart-qty="${index + 1}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-qty="${index + 1}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button><button type="button" class="drawer-remove" data-cart-qty="${index + 1}" data-qty="0">Remove</button></div></div></div>`;
      }).join('');
      if (drawerFoot) drawerFoot.hidden = false;
      if (drawerTotal) drawerTotal.textContent = formatMoney(cart.total_price);
      notifyCartUpdated(cart);
      return cart;
    } catch (_) {
      drawerBody.innerHTML = '<div class="drawer-empty"><strong>Could not load your cart.</strong><a class="btn" href="/cart">Open cart page</a></div>';
    }
  };

  const changeCart = async (line, quantity) => {
    try {
      const response = await fetch(cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!response.ok) throw new Error('Cart update failed');
      await renderDrawer();
    } catch (_) {}
  };

  document.querySelectorAll('[data-cart-drawer-open]').forEach(link => link.addEventListener('click', async (event) => {
    if (!drawer) return;
    event.preventDefault();
    setDrawerOpen(true);
    await renderDrawer();
  }));
  document.querySelector('[data-cart-drawer-close]')?.addEventListener('click', () => setDrawerOpen(false));
  overlay?.addEventListener('click', () => setDrawerOpen(false));

  // Checkout must always use Shopify's server-side checkout route.
  // This avoids theme/app click handlers accidentally swallowing the checkout link.
  document.querySelectorAll('.drawer-checkout, .cart-checkout-link').forEach(link => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const destination = link.getAttribute('href') || checkoutUrl;
      window.location.assign(destination);
    });
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') setDrawerOpen(false); });

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-qty]');
    if (button) changeCart(Number(button.dataset.cartQty), Number(button.dataset.qty));
  });

  // Keep page loads light: update only the cart count until the drawer is actually opened.
  const refreshCartCount = async () => {
    try {
      const response = await fetch(cartJsUrl, { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      updateHeaderCount(cart.item_count);
      notifyCartUpdated(cart);
    } catch (_) {}
  };
  if (drawerBody) refreshCartCount();

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden && drawerBody) refreshCartCount();
  });

  window.addEventListener('pageshow', () => {
    if (drawerBody) refreshCartCount();
  });

  // Product variant + compact low-stock UI. Uses only real Shopify inventory.
  document.querySelectorAll('[data-variant-select]').forEach(select => {
    const form = select.closest('form[action*="/cart/add"]');
    const stockBox = document.querySelector('[data-price-urgency]');
    if (!stockBox) return;
    const text = stockBox.querySelector('[data-price-urgency-text]');
    const threshold = Number(stockBox.dataset.lowStockThreshold || 5);
    const sync = () => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const qty = Number(option.dataset.inventoryQuantity || 0);
      const tracked = Boolean(option.dataset.inventoryManaged);
      const available = option.dataset.available !== 'false';
      stockBox.hidden = false;
      if (text) text.textContent = 'Hurry, Few Left!';
      const addButton = form?.querySelector('.add-button');
      if (addButton) addButton.disabled = !available || (tracked && qty <= 0);
      const priceEl = form?.closest('.product-info')?.querySelector('.product-price');
      const priceValue = option.dataset.price;
      if (priceEl && priceValue) {
        const compare = Number(option.dataset.compareCents || 0);
        const priceCents = Number(option.dataset.priceCents || 0);
        const existingCompare = priceEl.querySelector('.compare');
        const existingSave = priceEl.querySelector('.save-badge');
        priceEl.childNodes.forEach(node => { if (node.nodeType === 3 && node.textContent.trim()) node.textContent = ''; });
        let textNode = priceEl.querySelector('[data-current-price-text]');
        if (!textNode) { textNode = document.createElement('span'); textNode.dataset.currentPriceText = 'true'; priceEl.prepend(textNode); }
        textNode.textContent = priceValue;
        if (existingCompare) existingCompare.remove();
        if (existingSave) existingSave.remove();
        if (compare > priceCents) {
          const compareEl = document.createElement('span'); compareEl.className = 'compare'; compareEl.textContent = option.dataset.compareMoney || '';
          const saveEl = document.createElement('span'); saveEl.className = 'save-badge';
          saveEl.textContent = `${Math.round(((compare - priceCents) * 100) / compare)}% OFF`;
          priceEl.append(compareEl, saveEl);
        }
      }
      document.dispatchEvent(new CustomEvent('delderma:variant-updated'));
    };
    select.addEventListener('change', sync);
    sync();
  });

  // Product-page fixed header: keeps announcement + logo/search + navigation visible while scrolling.
  const headerStack = document.querySelector('.site-header-stack');
  if (headerStack && document.body.classList.contains('template-product') && !/^\/cart(?:\/|$)/.test(window.location.pathname)) {
    const syncFixedHeader = () => {
      const height = Math.ceil(headerStack.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--delderma-fixed-header-height', `${height}px`);
      document.body.style.paddingTop = `${height}px`;
    };
    headerStack.classList.add('delderma-fixed-header');
    syncFixedHeader();
    window.addEventListener('resize', syncFixedHeader, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(syncFixedHeader).observe(headerStack);
  }

  // Sticky purchase bar: keeps the primary purchase actions visible while browsing.
  // It delegates to the main product buttons so the same AJAX cart/checkout logic is used.
  const stickyCart = document.querySelector('[data-sticky-cart]');
  const isCartRoute = /^\/cart(?:\/|$)/.test(window.location.pathname);
  const isProductPage = document.body.classList.contains('template-product') && !isCartRoute;
  if (stickyCart && !isProductPage) stickyCart.hidden = true;
  const stickyAdd = isProductPage ? stickyCart?.querySelector('[data-sticky-add]') : null;
  const stickyBuy = isProductPage ? stickyCart?.querySelector('[data-sticky-buy]') : null;
  const stickyPrice = isProductPage ? stickyCart?.querySelector('[data-sticky-price]') : null;
  const mainProductForm = isProductPage ? document.querySelector('.product-info form[action*="/cart/add"]') : null;
  const mainAddButton = mainProductForm?.querySelector('.add-button');
  const mainBuyButton = isProductPage ? document.querySelector('[data-buy-now]') : null;
  const syncStickyPurchaseBar = () => {
    if (!stickyCart) return;
    const select = mainProductForm?.querySelector('[data-variant-select]');
    const option = select?.selectedOptions?.[0];
    if (option && stickyPrice) stickyPrice.textContent = option.dataset.price || stickyPrice.textContent;
    const available = option ? option.dataset.available !== 'false' : Boolean(mainAddButton && !mainAddButton.disabled);
    if (stickyAdd) stickyAdd.disabled = !available;
    if (stickyBuy) stickyBuy.disabled = !available;
  };
  stickyAdd?.addEventListener('click', () => {
    if (stickyAdd.disabled || !mainAddButton) return;
    mainAddButton.click();
  });
  stickyBuy?.addEventListener('click', () => {
    if (stickyBuy.disabled || !mainBuyButton) return;
    mainBuyButton.click();
  });
  mainProductForm?.addEventListener('change', syncStickyPurchaseBar);
  document.addEventListener('delderma:variant-updated', syncStickyPurchaseBar);
  syncStickyPurchaseBar();

  // Product Buy Now: add the selected variant and go straight to Shopify checkout.
  document.querySelectorAll('[data-buy-now]').forEach(button => {
    const form = button.closest('.product-info')?.querySelector('form[action*="/cart/add"]');
    if (!form || button.dataset.buyNowBound) return;
    button.dataset.buyNowBound = 'true';
    button.addEventListener('click', async () => {
      const variant = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      if (!variant?.value) return;
      button.disabled = true;
      const original = button.textContent;
      button.textContent = 'Opening checkout…';
      try {
        const body = new URLSearchParams();
        body.set('id', variant.value);
        body.set('quantity', quantity?.value || '1');
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body
        });
        if (!response.ok) throw new Error('Could not add product');
        window.location.href = checkoutUrl;
      } catch (_) {
        button.disabled = false;
        button.textContent = original;
        form.submit();
      }
    });
  });

  // AJAX product add: intercept every Shopify product form so the cart count and drawer
  // update instantly on product pages, including themes/sections with slightly different markup.
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
    if (form.dataset.ajaxBound) return;
    const button = form.querySelector('.add-button, [type="submit"]');
    if (!button) return;
    form.dataset.ajaxBound = 'true';
    form.addEventListener('submit', async (event) => {
      if (event.defaultPrevented || event.submitter?.name === 'checkout') return;
      event.preventDefault();
      if (button.disabled) return;
      button.disabled = true;
      const original = button.textContent.trim();
      button.textContent = 'Adding…';
      try {
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        });
        if (!response.ok) {
          let message = 'Add to cart failed';
          try { const errorData = await response.json(); message = errorData.description || message; } catch (_) {}
          throw new Error(message);
        }
        // Refresh and render the real server-side cart once, then open the drawer.
        button.textContent = 'Added ✓';
        if (stickyCart) stickyCart.hidden = true;
        setDrawerOpen(true);
        await renderDrawer();
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 800);
      } catch (error) {
        button.disabled = false;
        button.textContent = original;
        // Preserve native Shopify behavior if AJAX is unavailable.
        form.submit();
      }
    });
  });

  // Quick Add on product cards: adds the first available/default variant and opens cart drawer.
  document.querySelectorAll('[data-quick-add]').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = 'true';
    button.addEventListener('click', async (event) => {
      event.preventDefault(); event.stopPropagation();
      const variantId = button.dataset.variantId;
      if (!variantId) return;
      const original = button.textContent; button.disabled = true; button.textContent = 'Adding…';
      try {
        const body = new URLSearchParams(); body.set('id', variantId); body.set('quantity', '1');
        const response = await fetch(cartAddUrl, {method:'POST', headers:{'Accept':'application/json','Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}, body});
        if (!response.ok) throw new Error('Quick add failed');
        button.textContent = 'Added ✓';
        setDrawerOpen(true); await renderDrawer();
      } catch (_) { button.textContent = 'Try again'; }
      setTimeout(()=>{button.disabled=false;button.textContent=original;},900);
    });
  });

  // Wishlist: local browser storage, no external app required. Can be replaced by a wishlist app later.
  const wishlistKey='delderma_wishlist_v1';
  const getWishlist=()=>{try{return JSON.parse(localStorage.getItem(wishlistKey)||'[]')}catch(_){return[]}};
  const saveWishlist=(list)=>{try{localStorage.setItem(wishlistKey,JSON.stringify(list))}catch(_){}};
  document.querySelectorAll('[data-wishlist]').forEach(button=>{
    const handle=button.dataset.productHandle; const sync=()=>{button.classList.toggle('is-active',getWishlist().includes(handle));button.textContent=getWishlist().includes(handle)?'♥':'♡'}; sync();
    button.addEventListener('click',()=>{let list=getWishlist(); list=list.includes(handle)?list.filter(x=>x!==handle):[...list,handle]; saveWishlist(list); sync();});
  });

  // Product sharing with Web Share API / clipboard fallback.
  document.querySelectorAll('[data-share-product]').forEach(button=>button.addEventListener('click',async()=>{
    const data={title:document.title,url:window.location.href};
    try { if(navigator.share){await navigator.share(data)} else {await navigator.clipboard.writeText(window.location.href); button.textContent='Link copied ✓'; setTimeout(()=>button.textContent='↗ Share',1200)} } catch(_){ }
  }));

  // Pincode UI validation. This does not verify courier serviceability without a shipping API.
  document.querySelectorAll('[data-pincode-check]').forEach(button=>button.addEventListener('click',()=>{
    const box=button.closest('[data-pincode-box]'), input=box?.querySelector('[data-pincode]'), result=box?.querySelector('[data-pincode-result]');
    const pin=(input?.value||'').trim();
    if(!result)return; if(!/^\d{6}$/.test(pin)){result.textContent='Please enter a valid 6-digit pincode.';return} result.textContent='Pincode accepted. Final delivery date and COD availability will be confirmed at checkout.';
  }));

  // Lightweight recently-viewed product handles stored locally. Product cards are rendered from handles via Shopify search suggestions.
  const recent=document.querySelector('[data-recently-viewed]');
  if(recent){
    const current=recent.dataset.currentProduct; let list=[]; try{list=JSON.parse(localStorage.getItem('delderma_recent_v1')||'[]')}catch(_){list=[]}
    list=[current,...list.filter(x=>x!==current)].slice(0,6); try{localStorage.setItem('delderma_recent_v1',JSON.stringify(list))}catch(_){ }
    const holder=recent.querySelector('[data-recent-products]');
    Promise.all(list.slice(1,5).map(h=>fetch(`/products/${encodeURIComponent(h)}.js`).then(r=>r.ok?r.json():null).catch(()=>null))).then(items=>{
      const valid=items.filter(Boolean); if(!valid.length){recent.hidden=true;return;}
      holder.innerHTML=valid.map(p=>`<article class="card product-card"><div class="card-img"><a href="${p.url}"><img loading="lazy" src="${p.featured_image||''}" alt="${(p.title||'').replace(/"/g,'&quot;')}"></a></div><div class="card-body"><a class="card-title" href="${p.url}">${p.title}</a><div class="card-meta"><div class="price">${formatMoney(p.price)}</div><a class="view-arrow" href="${p.url}">→</a></div></div></article>`).join('');
    });
  }
});
